export default "__VITE_ASSET__7a738d3b__"